<template>
  <v-alert
    v-if="show"
    prominent
    text
    outlined
    color="primary"
    class="mt-6 text-body-1"
  >
    <v-row>
      <v-col cols="auto">
        <v-icon
          color="primary"
        >
          fa fa-info-circle
        </v-icon>
      </v-col>
      <v-col class="pl-0">
        {{ label }}
      </v-col>
      <v-col cols="auto">
        <v-btn
          x-small
          icon
          color="primary"
          @click="show = !show"
        >
          <v-icon
            color="primary"
          >
            fa fa-times
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>

export default {
  name: 'InfoLabel',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: true
    }
  }
}

</script>
